export type ClientType = 'Individual' | 'Company' | 'Trust' | 'Sole Trader' | 'Partnership';

export type StatusType = 'Pending' | 'In Progress' | 'Completed' | 'Overdue' | 'Not Required';

export type BookkeepingSoftware = 'Xero' | 'MYOB' | 'QuickBooks' | 'Reckon' | 'Other' | 'None';

export interface Client {
  id: string;
  srNo: number;
  directorName: string;
  natureOfBusiness: string;
  companyName: string;
  clientType: ClientType;
  gstFilling: boolean;
  abn: string;
  tfn: string;
  emailAddress: string;
  team: string;
  employee: string;
  statementReceived: boolean;
  basStatus: StatusType;
  basReturn: StatusType;
  payrollPayslip: StatusType;
  stpFile: StatusType;
  superPayment: StatusType;
  bookkeepingSoftware: BookkeepingSoftware;
  handyLedger: boolean;
  bookkeepingStatus: StatusType;
  invoices: StatusType;
  remarks: string;
  createdAt: Date;
  updatedAt: Date;
}

export const defaultClient: Omit<Client, 'id' | 'srNo' | 'createdAt' | 'updatedAt'> = {
  directorName: '',
  natureOfBusiness: '',
  companyName: '',
  clientType: 'Individual',
  gstFilling: false,
  abn: '',
  tfn: '',
  emailAddress: '',
  team: '',
  employee: '',
  statementReceived: false,
  basStatus: 'Pending',
  basReturn: 'Pending',
  payrollPayslip: 'Not Required',
  stpFile: 'Not Required',
  superPayment: 'Not Required',
  bookkeepingSoftware: 'None',
  handyLedger: false,
  bookkeepingStatus: 'Pending',
  invoices: 'Pending',
  remarks: '',
};
